module.exports = __webpack_public_path__ + "img/colaborador(3).e2614dcf.png";